// src/components/GameSummaryMobile.jsx
import React from 'react';
import '../styles/QuestionGameSummaryMobile.css';

export default function QuestionGameSummaryMobile({ scoreboard, handleLeaveLobby, handleReturnToLobby }) {
    const sorted = [...scoreboard].sort((a, b) => b.score - a.score);
    const ranked = sorted.map((player, index) => ({
        ...player,
        rank: index + 1
    }));

    const getMedalClass = (rank) => {
        switch (rank) {
            case 1: return 'gold';
            case 2: return 'silver';
            case 3: return 'bronze';
            default: return '';
        }
    };

    return (
        <div className="game-summary-lite">
            <div className="lite-title">Ergebnisse</div>
            <div className="lite-divider">
                <span className="lite-divider-line" />
                <span className="lite-divider-diamond" />
                <span className="lite-divider-line" />
            </div>
            {ranked.map(player => (
                <div key={player.persistentId} className={`lite-player ${getMedalClass(player.rank)}`}>
                    <div className="name">
                        {player.rank === 1 && <i className="fas fa-crown" style={{ color: '#ffd700', marginRight: 6 }} />}
                        {player.rank === 2 && <i className="fas fa-medal" style={{ color: '#c0c0c0', marginRight: 6 }} />}
                        {player.rank === 3 && <i className="fas fa-medal" style={{ color: '#cd7f32', marginRight: 6 }} />}
                        {player.name}
                    </div>
                    <div className="score"><i className="fas fa-star" /> {player.score}</div>
                </div>
            ))}

            <div className="summary-actions" style={{ marginTop: '2rem' }}>
                <button className="button button-primary" onClick={handleReturnToLobby}>
                    <i className="fas fa-users"></i> Zurück zur Lobby
                </button>
                <button className="button button-primary" onClick={handleLeaveLobby}>
                    <i className="fas fa-home"></i> Zurück zur Startseite
                </button>
            </div>
        </div>
    );
}
